export const THREAD_CREATION_FIELD_IDS = {
  toField: {
    solid: 'person-phone-selection-solid-field',
    default: 'person-phone-selection-field',
  },
  fromField: 'department-selection-field',
} as const;
